var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "container" } }, [
    _c(
      "div",
      { staticClass: "container_wrap" },
      [
        _c("keep-alive", [_c("admin-snb")], 1),
        _vm._v(" "),
        _c("div", { attrs: { id: "contents" } }, [
          _c("div", { staticClass: "contents_wrap" }, [
            _c(
              "div",
              { staticClass: "landing_item" },
              [
                _c("skp-breadcrumbs", {
                  on: {
                    "page-title": function(val) {
                      return (_vm.pageTitle = val)
                    }
                  }
                }),
                _vm._v(" "),
                _c("h2", { staticClass: "pg_title" }, [
                  _vm._v(_vm._s(_vm.pageTitle))
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("em", [
                    _vm._v("Only the previous version of SKP is available. ")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "em",
                    {
                      staticClass: "txt_color1",
                      staticStyle: { "font-weight": "700" }
                    },
                    [
                      _vm._v(
                        "\n                            Warning : If you are not an authorized administrator of samsung.com, leave this menu immediately.\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "em",
                    {
                      staticClass: "txt_color1",
                      staticStyle: { "font-weight": "700" }
                    },
                    [
                      _vm._v(
                        "\n                            Caution : This menu is in service to public users. Any kind of operation on this menu will be published on samsung.com\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.btnPopupOpen }
                    },
                    [_vm._v("Click")]
                  )
                ])
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a0c3e86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0c3e86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/DotComMain.vue
// module id = pVeU
// module chunks = 0